import { Banner, Category, PageInfo, Post, } from 'generated-graphql';
import React, { ChangeEvent, useState } from 'react';
import { useLazyQuery } from '@apollo/client';
import { useRouter } from 'next/router';
import debounce from 'lodash/debounce';
import { getPosts } from 'gql/posts';
import ResourceItem from '@/components/ResourceItems/ResourceItem';
import ResourceItemFullWidth from '@/components/ResourceItems/ResourceItemFullWidth';
import Link from 'next/link';
import { FourthTitle } from '@/componentsWP/StyledComponentsLib/StyledComponentsLib';
import FiltersSingle from '@/components/Filters/FiltersSingle';
import Head from 'next/head';
import styles from './ResourcesPage.module.scss'

const series = ['Agents of Change', 'Unboxed'];

const ResourcesPage = ({
  pageData,
  categories,
  c,
  pageInfo,
  banners,
  featured
}: {
  pageData: Post[];
  categories: Category[];
  c?: Category;
  pageInfo: PageInfo,
  banners?: Banner[] | [];
  featured: Post[];
}) => {

  const [search, setSearch] = useState<string>('');
  const [items, setItems] = useState<Post[]>([...featured, ...pageData.filter((p) => !featured.find((f) => f.id === p.id))]);

  const cFilter: string[] = [];
  let isSeries = false;
  let cSlug = 'all';
  if (c && c.name) {
    cFilter.push(c.name);
    isSeries = series.includes(String(c.name));
    cSlug = c.slug || '';
  }

  const [filterItems, { loading }] = useLazyQuery(
    getPosts(
      cFilter,
    ),
  );
  const [page, setPage] = useState<PageInfo>(pageInfo);

  const router = useRouter();
  const { asPath } = router;

  const handleSearch = (value: string) => {
    filterItems({
      variables: { search: value },
      onCompleted: (data) => {
        setItems(data.posts?.nodes); setPage(data?.posts?.pageInfo);
      },
    });
  };

  const debouncedHandleSearch = debounce(handleSearch, 300);
  const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    setSearch(event.target.value);
    debouncedHandleSearch(event.target.value);
  };


  const handleLoadMore = () => {
    filterItems({
      variables: {
        after: page.endCursor,

      },
      onCompleted: (data) => {
        setItems((els) =>
          els
            ? [...els, ...(data?.posts?.nodes)]
            : data.posts.nodes,
        );
        setPage(data?.posts?.pageInfo);
      },
    });
  };

  const smallItems = isSeries && !loading ? items : items.slice(1);

  return (
    <>
      <Head>
        <title>Resources - Agent3</title>
        <meta name="description" content="Our latest thinking from across the Agent3 Group." />
      </Head>
      <div style={{ marginTop: '100px' }} className={styles.resourcePage}>
        <div className='container'>
          <div className='row'>
            <div className='col-xl-7 mb-5 mt-5'>
              <p className='md semibold mb-3'>Agent3 Group Resources</p>
              <h1 className='xl'>Our latest thinking from across the Agent3 Group.</h1>
            </div>
          </div>
        </div>

        <div className="container">
          <div className="row">
            <FiltersSingle categories={categories} search={search} onSearch={handleInputChange} c={c} />
            <div className={`col-md-9 mainList`}>
              {!items.length ? <div className='d-flex justify-content-center'><FourthTitle style={{ fontWeight: 600, padding: "10% 0", textAlign: "center" }}> No resources found by your search criteria</FourthTitle> </div> : <div><div className="row">
                {c?.description && c.color?.descriptionImage?.mediaItemUrl &&
                  <div className="col-12 px-3">
                    <div className={`position-relative p-5 d-flex align-items-center ${styles.descriptionWrapper}`}
                      style={{ background: `url(${c.color.descriptionImage.mediaItemUrl})`, color: c.color.color || '' }} dangerouslySetInnerHTML={{ __html: c.description }} />
                  </div>}
                <div className="col-12 px-3">
                  {items.length > 0 && !isSeries && (
                    <ResourceItemFullWidth item={items[0]} />
                  )}
                </div>
                {banners?.length && isSeries && !loading ? banners.map((b) => <div key={b.id} className='col-12'><Link href={b.banner?.url || ""}><img className={`img-fluid w-100 ${styles.banner}`} src={b.banner?.image?.mediaItemUrl || ""} /></Link> </div>) : null}
                {smallItems.map((w: Post, idx) => (
                  <React.Fragment key={idx + 'resource'}>
                    {/* {w?.banners?.nodes.length && isSeries && !loading ? <div className='col-12'><Link style={{ display: "inline-block", margin: "24px 0", width: "100%" }} href={w.banners.nodes[0].banner?.url || ""}><img className='img-fluid w-100' src={w.banners.nodes[0].banner?.image?.mediaItemUrl || ""} /></Link> </div> : null} */}
                    <div key={idx + 'resource'} className="col-12 col-xl-6 px-3">
                      <ResourceItem item={w} isFeatured={!!featured.find((item) => item.id === w.id) && idx < 4} />
                    </div>
                  </React.Fragment>

                ))}
              </div><div className="w-100 d-flex flex-column align-items-center">
                  <Link
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      handleLoadMore();
                    }}
                    href={`/resources/c/${cSlug}/${page.endCursor}`}
                    className={`mb-5 mt-5 cta ${!page.hasNextPage ? "disabled" : ''}`}

                  >
                    Load more
                  </Link>
                </div></div>}

            </div>
          </div>

        </div>
      </div>
    </>
  );
};

export default ResourcesPage;
